/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import {
  TextInput,
  Button,
  Table,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  Loading,
  TableCell,
  Checkbox,
  FormLabel,
  FormGroup,
  TextArea,
  TextInputSkeleton,
  DropdownSkeleton,
  DatePickerSkeleton,
} from 'carbon-components-react';

import '../../scss/custom.scss';
import SimpleReactValidator from 'simple-react-validator';
import { Information16, CheckmarkOutline16, Delete16, Download16 } from '@carbon/icons-react';
import { v4 as uuid } from 'uuid';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { ComboBox } from '../../helpers/ComboBox';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  STATUS,
  apioperation,
  entitiesLabels,
  DateFormat,
  CarType,
} from '../../helpers/Constants';
import DateTimePicker from '../../helpers/DateTimePicker';
import { api, registry, audit } from '../../helpers/api/api';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { IsEditable, CanExecuteAction } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { HistoryTable } from '../../helpers/HistoryTable';
import FileUpload from '../common/FileUpload';
import { WFActionModal } from '../common/WFActionModal';
import FileDownLoadButton from '../common/FileDownloadButton';
import { Online, Offline } from '../common/OnLineOffLine';
import AuditRepository from '../../helpers/api/AuditRepository';
import moment from 'moment';
import AttachmentTable from '../common/AttachmentTable';

export default class AuditCADetail extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.validatorReminder = new SimpleReactValidator();
    const idAuditEdit = props ? props.match.params.id : '';
    const isNewCarManagement = props ? Number(props.match.params.newMng) : 0;
    const idAnswer = props ? props.match.params.idAnswer : '';
    const idCar = props ? props.match.params.idCar : '';
    const idCa = props ? props.match.params.idCa : '';

    this.state = {
      idAuditEdit,
      isNewCarManagement,
      idAnswer,
      idCar,
      idCa,
      isLoading: true,
      isSubmitted: false,
      model: null,
      keyCA: `formCA_${new Date().getTime()}`,
      appStatus: null,
      isDisabled: true,
      isHistoryModalOpen: false,
      // /Status Action
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      approvalStartDate: null,
      approvalEndDate: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      editEffectiveness: null,
      isAdequate: undefined, // bool
      evidencesAttached: undefined,
      checkEffectiveness: null, // ''
      dateCheck: null, // date
      isCorrectiveActionsSuitable: null, //RITM0945960
      appCorrectiveActionsSuitable: [ //RITM0945960
        { id: 'option-1', text: 'Yes' },
        { id: 'option-2', text: 'No' },

    ],
      // /Status Action
    };
    this.baseUrl = `${idAuditEdit}/answer/${idAnswer}/car/${idCar}/ca/${idCa}/detail`;
    this.repository = new AuditRepository();
  }

  baseUrl;

  componentDidMount() {
    this.getCA();
    this.getStatus();
  }

  showButtonHistory = () => (
    <Button
      className="action-button-modal"
      kind="secondary"
      renderIcon={Information16}
      onClick={() => this.openModalHistory()}
    >
      History
    </Button>
  );

  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };

  getStatus = () => {
    registry
      .getAll('status')
      .then((response) => {
        const { data } = response;
        // data = data != null ? data.filter(item => (item.id == 1 || item.id == 4)) : [];
        this.setState({
          appStatus: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.STATUS, apioperation.GET)
        );
      })
      .finally(() => {});
  };

  getCA = () => {
    this.setState({
      isLoading: true,
    });

    audit
      .getAll(this.baseUrl)
      .then((response) => {
        const { data } = response;
        if (data) {
          this.setState({
            model: data,
          });
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CA, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  showLoading() {
    const show = this.state.isLoading || this.state.isSubmitted;
    const descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active withOverlay description={descr} />;
    // return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state.model };
    if (objName && objName !== 'model') statusCopy[objName][inputName] = inputValue;
    else statusCopy[inputName] = inputValue;

    this.setState({ model: statusCopy });
  };

  handleChangeModel = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const objName = el.target.alt;

    this.updateState(inputName, inputValue, objName);
  };

  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;
    this.updateState(inputName, inputValue, objName);
  };

  handleChangeComboName = (inputName, selectedItem, objName) => {
    if (selectedItem != null) {
      selectedItem.id = selectedItem.name;
    }
    this.handleChangeCombo(inputName, selectedItem, objName);
  };

  saveCA = () => {
    if (this.state.model.auditCAR.idStatus === 4) { //RITM1010580/RITM1010550
      if (this.validatorReminder.allValid()) {
        const datiForm = this.state.model;
        if (!datiForm) return;

        this.setState({
          isSubmitted: true,
        });

        audit
          .put(this.baseUrl, datiForm, '')
          .then(async (response) => {
            if (response.status === 200) {
              showNotification.success(
                `${entitiesLabels.SUCCESS}`,
                getSuccess(entitiesLabels.CA, apioperation.PUT)
              );
              await this.repository.updateCachedCaDetails(datiForm);
              this.getCA();
            } else {
              showNotification.error();
            }
          })
          .catch((error) => {
            showNotification.error(
              `${entitiesLabels.ERROR}`,
              getError(error, entitiesLabels.STATUS, apioperation.PUT)
            );
          })
          .finally(() => {
            this.setState({
              isSubmitted: false,
            });
          });
      } else {
        this.validatorReminder.showMessages();
        showNotification.warning(`${entitiesLabels.WARNING}`, 'field not valid');
        this.forceUpdate();
      }
    } else if (this.validator.allValid()) {
      const datiForm = this.state.model;
      if (!datiForm) return;

      this.setState({
        isSubmitted: true,
      });

      audit
        .put(this.baseUrl, datiForm, '')
        .then(async (response) => {
          if (response.status === 200) {
            await this.repository.updateCachedCaDetails(datiForm);
            showNotification.success(
              `${entitiesLabels.SUCCESS}`,
              getSuccess(entitiesLabels.CA, apioperation.PUT)
            );
            this.getCA();
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.STATUS, apioperation.PUT)
          );
        })
        .finally(() => {
          this.setState({
            isSubmitted: false,
          });
        });
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`, ' field not valid');
      this.forceUpdate();
    }
  };

  getBackUrl = () => {
    const hash = this.props.location.hash || '';

    return `/audit/${this.state.idAuditEdit}/${this.state.isNewCarManagement}/answer/${this.state.idAnswer}/car/${this.state.idCar}${hash}`;
    // if (this.props.history.length == 1)
    //     console.log("TODO, Chiudere la pagina???")
    // else
    //     this.props.history.goBack()
  };

  cancel = () => {
    this.props.history.push(this.getBackUrl());
  };

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: [this.state.idCa],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(
        `/audit/${this.state.idAuditEdit}/answer/${this.state.idAnswer}/car/${this.state.idCar}/ca/${apiEndpoint}`,
        data,
        ''
      )
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.CA, apioperation.PUT)
          );
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            isLoading: true,
            // model: null
          });
          this.getCA();
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CA, apioperation.PUT)
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  IsRowSelectable() {
    const row = this.state.model;
    if (row == null) return false;

    return true;
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    if (this.validator.allValid()) {
      this.setState({
        approvalModalAction: actionName,
        isApprovalModalOpen: true,
        isLoadingApproverOptions: true,
        withApprover,
        selectedData: selectedRows,
        approverRole,
        approvalEndpoint: actionKey,
        approvalNotesRequired,
      });
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`, ' field not valid');
      this.forceUpdate();
    }
  }

  clearAttachment = () => ({
    id: null, // guid
    fileIdentifier: null,
    name: null,
    contentType: null,
    size: null,
    type: null,
  });

  remove = (id) => {
    if (!id) return;

    const statusCopy = { ...this.state.model };
    statusCopy.attachment = statusCopy.attachment.filter((el) => el.id !== id);

    this.setState({
      model: statusCopy,
    });
  };

  onUpload = (fileIdentifier, fileName, fileType, size) => {
    const attachment = { ...this.state.attachment };

    attachment.id = uuid();
    attachment.fileIdentifier = fileIdentifier.blobName;
    attachment.name = fileName;
    attachment.contentType = fileType;
    attachment.size = size;
    // attachment.filePath = file.localPath;

    this.setState({
      attachment: this.clearAttachment(),
    });

    try {
      if (attachment == null) return;
      // insert
      const oldattachment = this.state.model.attachment || [];

      const newItem = {
        id: uuid(), // guid

        idAttachment: attachment.id, // guid
        attachment,
      };

      const newattachment = oldattachment.concat([newItem]);
      this.updateState('attachment', newattachment, 'model');
    } catch (error) {
        showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.ATTACHMENT, apioperation.UPLOAD)
        );
    }
  };

  getStatusActions = (user) => {
    if (!this.IsRowSelectable()) return null;

    //STEFANO 28-06-2021

    // const canEditResource = this.state.model && {
    //   email:
    //     this.state.model.auditCAR.owner != null
    //       ? this.state.model.auditCAR.owner.email
    //       : this.state.model.auditCAR.ownerSaipem.email,
    // };

    const canEditResource = this.state.model && {
      email:
        this.state.model.owner != null && this.state.model.owner.email != null
          ? this.state.model.owner.email
          : this.state.model.owner?.employer?.email,
    };

    //STEFANO 28-06-2021


    const { idStatus } = this.state.model;
    return (
      <>
        {CanExecuteAction('Audit', 'CAManagement', user, idStatus, 'Close', canEditResource) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() => {this.saveCA(); this.batchActionClick('Close', 'Close', null, false, false, null)}}
          >
            Close CA
          </Button>
        ) : null}

        {CanExecuteAction('Audit', 'CAManagement', user, idStatus, 'Open', canEditResource) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() => this.batchActionClick('Open', 'Open', null, false, false, null)}
          >
            Open CA
          </Button>
        ) : null}
      </>
    );
  };

  render() {
    const validations = {
      immediateThreatment: this.state.model
        ? this.validator.message(
            'immediateThreatment',
            this.state.model.immediateThreatment,
            'required'
          )
        : null,
      explain: this.state.model
        ? this.validator.message('explain', this.state.model.explain, 'required')
        : null,
    };
    const validationsReminder = {
      checkEffectiveness: this.state.model
        ? this.validatorReminder.message(
            'checkEffectiveness',
            this.state.model.checkEffectiveness,
            'required'
          )
        : null,
      dateCheck: this.state.model
        ? this.validatorReminder.message('dateCheck', this.state.model.dateCheck, 'required')
        : null,
      //RITM0945960 - Effectiveness Check Modification
      isCorrectiveActionsSuitable: this.state.model 
        ? this.validatorReminder.message('isCorrectiveActionsSuitable', this.state.model.isCorrectiveActionsSuitable, 'required')
        : null,
      //End
    };
    const selectedItemCombo = {
      idStatus: this.state.model
        ? (this.state.appStatus || []).find(
            (el) =>
              el.id === (this.state.model.isClose ? STATUS.Consolidated : this.state.model.idStatus)
          )
        : null,
      appStatus: (this.state.appStatus || []).filter(
        (el) => el.id === STATUS.Submitted || el.id === STATUS.Consolidated
      ),
      isCorrectiveActionsSuitable: this.state.model
        ? (this.state.appCorrectiveActionsSuitable || []).find(
            (el) =>
              el.text === this.state.model.isCorrectiveActionsSuitable
            )
        : null,  
    };

    const owner = this.state.model && this.state.model.owner;
    const rows = this.state.model?.attachment || [];
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo={this.getBackUrl()}
              linkText="FINDING Detail"
              titleLeft={`Audit Id: ${
                (this.state.model && this.state.model.auditCode) || ''
              } - CA Detail`}
              titleCenter={this.state.model && `ID: ${this.state.model.auditCACode}`}
              titleRight={
                this.state.model && this.state.model.status
                  ? this.state.model.status.caManagementName
                  : null
              }
              batchActions={this.getStatusActions(user)}
              showButtonHistory={this.showButtonHistory()}
            />
            <div className="mainContainer">
              {this.showLoading()}
              <WFActionModal
                show={this.state.isApprovalModalOpen}
                title={`${this.state.approvalModalAction} Audit CAs`}
                action={this.state.approvalModalAction}
                withApprover={this.state.withApprover}
                approver={this.state.approver}
                approverRole={this.state.approverRole}
                approverOptions={this.state.approvers}
                isLoadingOperation={this.state.isLoadingWFOperation}
                onApproverSelect={this.handleApproverSelect}
                isLoadingOptions={this.state.isLoadingApproverOptions}
                onCancel={this.handleCloseApprovalModal}
                onConfirm={this.handleConfirmApprovalModal}
                onApprovalNotesChange={this.handleApprovalNotesChange}
                approvalNotes={this.state.approvalNotes}
                approvalNotesRequired={this.state.approvalNotesRequired}
                validationMessages={this.state.approvalValidationMessages}
              />
              <HistoryTable
                entityId={this.state.idCa}
                isOpenModal={this.state.isHistoryModalOpen}
                onClose={() => this.closeModalHistory()}
                masked={this.state.model?.auditCAR.audit.maskedValue} //RITM1133680 Start - Anonimization AUDIT Module                
              />
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <div className="bx--row">
                    <div className="bx--col-lg-12">
                      <div className="bx--grid--full-width">
                        <div className="bx--row">
                          <div className="bx--col--md-12 bx--col-lg-12">
                            <FormGroup legendText="Cause of inefficiency">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextArea
                                  maxLength={5000}
                                  id="causeOfInefficiency"
                                  placeholder="Cause of inefficiency"
                                  value={this.state.model.causeOfInefficiency || ''}
                                  hideLabel
                                  labelText=""
                                  light
                                  rows={4}
                                  cols={225}
                                  className="disable-text"
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-12 bx--col-lg-12">
                            <FormGroup
                              legendText={
                                this.state.model?.auditCAR?.carType == CarType.NC.Code
                                  ? 'Corrective action to be implemented'
                                  : 'Corrective action to be implemented/Recommended Action'
                              }
                            >
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextArea
                                  maxLength={5000}
                                  id="caImplemented"
                                  placeholder="Corrective action"
                                  value={this.state.model.caImplemented || ''}
                                  hideLabel
                                  labelText=""
                                  light
                                  rows={4}
                                  cols={225}
                                  className="disable-text"
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col-lg-12 bx--col-md-12">
                            <FormGroup legendText="Details on inefficiency/potential inefficienty/strength">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextArea
                                  maxLength={5000}
                                  id="inefficiency"
                                  placeholder=""
                                  value={this.state.model.auditCAR?.inefficiency || ''}
                                  hideLabel
                                  labelText=""
                                  light
                                  rows={4}
                                  cols={225}
                                  className="disable-text"
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col-lg-12 bx--col-md-12">
                            <FormGroup legendText="Reference Documents">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextArea
                                  maxLength={5000}
                                  id="referenceDocuments"
                                  placeholder=""
                                  value={this.state.model.auditCAR.referenceDocuments || ''}
                                  hideLabel
                                  labelText=""
                                  light
                                  rows={4}
                                  cols={225}
                                  className="disable-text"
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col-md-4 bx--col-lg-6">
                            <FormGroup legendText="Finding/NC Level">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="type"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  defaultValue={this.state.model.auditCAR.type || ''}
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-6 bx--col-lg-6">
                            <FormGroup legendText="Classification Type - List 1">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="r2"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  defaultValue={this.state.model.auditCAR.findingsLevel1}
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-6 bx--col-lg-6">
                            <FormGroup legendText="Classification Type - List 2">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="r3"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  defaultValue={this.state.model.auditCAR.findingsLevel2}
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-6 bx--col-lg-6">
                            <FormGroup legendText="Classification Type - List 3">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="r4"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  defaultValue={this.state.model.auditCAR.findingsLevel3}
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-6 bx--col-lg-6">
                            <FormGroup legendText="Classification Type - List 4">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="r5"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  defaultValue={this.state.model.auditCAR.findingsLevel4}
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>

                          {/* <div className="bx--col--md-6 bx--col-lg-6">
                            <FormGroup legendText="Type" >
                                {
                                    !owner ?
                                        <TextInputSkeleton hideLabel />
                                        :
                                        <TextInput
                                            id="txt-type"
                                            type="text"
                                            labelText=""
                                            className="bx--text-input disable-text"
                                            value={this.state.model.owner.type || ''}
                                            disabled={true}
                                        />
                                }
                              </FormGroup>
                          </div> */}
                          <div className="bx--col--md-6 bx--col-lg-6">
                            <FormGroup legendText="CA Owner">
                              {!owner ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-fullname"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.owner.fullname || ''}
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>

                          <div className="bx--col--md-6 bx--col-lg-6">
                            <FormGroup legendText="Due Date">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-dueDate"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={switchDateFormat(this.state.model.dueDate, 'date')}
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-6 bx--col-lg-6">
                            <FormGroup legendText="Due Date Change Notes">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-dueDateChangeNotes"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.dueDateChangeNotes || ''}
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-6 bx--col-lg-6">
                            <FormGroup legendText="Status*">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : IsEditable(
                                  'Audit',
                                  'CAManagement',
                                  user,
                                  this.state.model.idStatus,
                                  'Status',
                                  { email: this.state.model.owner.email }
                                ) ? (
                                this.state.appStatus == null ? (
                                  <DropdownSkeleton />
                                ) : (
                                  <ComboBox
                                    id="isClose"
                                    placeholder="Select"
                                    name="isClose"
                                    alt="model"
                                    onChange={(name, val) =>
                                      this.updateState(
                                        'isClose',
                                        !!(val && val.id === STATUS.Consolidated),
                                        'model'
                                      )
                                    }
                                    itemToString={(item) => (item ? item.caManagementName : '')}
                                    initialSelectedItem={selectedItemCombo.idStatus}
                                    items={selectedItemCombo.appStatus}
                                  />
                                )
                              ) : (
                                <TextInput
                                  id="txt-status"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={
                                    this.state.model.status &&
                                    this.state.model.status.caManagementName
                                  }
                                  disabled
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col-md-6 bx--col-lg-6">
                            <FormGroup legendText="Actual date of completion of CA">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <div className="bx--col-md-4 bx--col-lg-6 pl-0">
                                  {!this.state.model ? (
                                    <DatePickerSkeleton />
                                  ) : (
                                    <DateTimePicker
                                      value={this.state.model?.actualDateCompletition}
                                      type="date"
                                      disableFutureDate
                                      placeholder={DateFormat}
                                      name="actualDateCompletition"
                                      alt="model"
                                      id="actualDateCompletition"
                                      onChange={this.updateState}
                                      disabled={!(IsEditable(
                                        'Audit',
                                        'CAManagement',
                                        user,
                                        this.state.model.idStatus,
                                        'Status',
                                        { email: this.state.model.owner.email }
                                      )) || this.state.model.idStatus == 4}
                                    />
                                )}
                              </div>
                              )}
                            </FormGroup>
                          </div>

                          <div className="bx--col--md-12 bx--col-lg-12">
                            <FormGroup legendText="Evidence of Corrective Action*">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextArea
                                  maxLength={5000}
                                  id="immediateThreatment"
                                  placeholder="Input Evidence of Corrective Action"
                                  value={this.state.model.immediateThreatment || ''}
                                  onChange={(el) =>
                                    this.updateState(
                                      'immediateThreatment',
                                      el.target.value,
                                      'model'
                                    )
                                  }
                                  hideLabel
                                  labelText=""
                                  light
                                  rows={4}
                                  cols={225}
                                  className="disable-text"
                                  invalid={validations.immediateThreatment != null}
                                  disabled={
                                    !IsEditable(
                                      'Audit',
                                      'CAManagement',
                                      user,
                                      this.state.model.idStatus,
                                      'ImmediateThreatment',
                                      { email: this.state.model.owner.email }
                                    )
                                  }
                                />
                              )}
                              {validations.immediateThreatment}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-12 bx--col-lg-12">
                            <FormGroup legendText="Explain*">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextArea
                                  maxLength={5000}
                                  id="explain"
                                  placeholder="Explain"
                                  value={this.state.model.explain || ''}
                                  onChange={(el) =>
                                    this.updateState('explain', el.target.value, 'model')
                                  }
                                  hideLabel
                                  labelText=""
                                  light
                                  rows={4}
                                  cols={225}
                                  className="disable-text"
                                  invalid={validations.explain != null}
                                  disabled={
                                    !IsEditable(
                                      'Audit',
                                      'CAManagement',
                                      user,
                                      this.state.model.idStatus,
                                      'ImmediateThreatment',
                                      { email: this.state.model.owner.email }
                                    )
                                  }
                                />
                              )}
                              {validations.explain}
                            </FormGroup>
                            {/* DEV_383 */}
                            <AttachmentTable
																storagePath="audit"
																model={this.state.model}
																items={this.state.model?.attachment}
																apiDownloadUrl={`/audit/${this.state.idAuditEdit}/answer/${this.state.idAnswer}/car/${this.state.idCar}/ca/${this.state.idCa}/attachment/`}
																onUploadFIle={this.onUpload}
																onDeleteFile={this.remove}
																isDisabled={ !IsEditable(
                                  'Audit',
                                  'CAManagement',
                                  user,
                                  this.state.model?.idStatus,
                                  'ImmediateThreatment',
                                  { email: this.state.model?.owner.email }
                                ) || this.state.model?.idStatus == 4 }
															/> 
                            {/* DEV_383 */}
                            
                          </div>
                            {IsEditable(
                              'Audit',
                              'CARManagement',
                              user,
                              this.state.model?.idStatus,
                              'Effectiveness',
                              this.state.model?.auditCAR
                            ) &&
                            this.state.model.emailCompilerAuditReport === user.email &&
                            this.state.model.auditCAR?.idStatus === 4 ? (
                              <div className="bx--col-md-4 bx--col-lg-4">
                                <FormGroup legendText="Audit Team has analyzed the Corrective Action and their evidences of closing and has assessed them as adequate">
                                  <Checkbox
                                    id="isAdequate"
                                    alt="model"
                                    labelText=""
                                    checked={this.state.model.isAdequate}
                                    onChange={(value, id) => this.updateState(id, value, 'model')}
                                  />
                                </FormGroup>
                              </div>
                            ) : null}

                            {IsEditable(
                              'Audit',
                              'CARManagement',
                              user,
                              this.state.model?.idStatus,
                              'Effectiveness',
                              this.state.model?.auditCAR
                            ) &&
                            (this.state.model.auditCAR?.owner?.email === user.email ||
                              this.state.model.auditCAR?.ownerSaipem?.email === user.email ||
                              this.state.model.emailCompilerAuditReport === user.email) &&
                            this.state.model.auditCAR?.idStatus === 4 ? (
                              <>
                                {' '}
                                <div className="bx--col-md-4 bx--col-lg-4">
                                  <FormGroup legendText="Evidences are attached">
                                    <Checkbox
                                      id="evidencesAttached"
                                      alt="model"
                                      labelText=""
                                      checked={this.state.model.evidencesAttached}
                                      onChange={(value, id) => this.updateState(id, value, 'model')}
                                      disabled={
                                        this.state.model.emailCompilerAuditReport === user.email
                                      }
                                    />
                                  </FormGroup>
                                </div>
                                <div className="bx--col--md-12 bx--col-lg-12">
                                  <FormGroup legendText="Check of the effectiveness of the CA">
                                    <TextArea
                                      maxLength={5000}
                                      id="checkEffectiveness"
                                      placeholder="Check of the effectiveness of the CA"
                                      value={this.state.model.checkEffectiveness || ''}
                                      onChange={(el) =>
                                        this.updateState(
                                          'checkEffectiveness',
                                          el.target.value,
                                          'model'
                                        )
                                      }
                                      hideLabel
                                      labelText=""
                                      light
                                      rows={4}
                                      cols={200}
                                      invalid={validationsReminder.checkEffectiveness != null}
                                      disabled={
                                        this.state.model.emailCompilerAuditReport === user.email
                                      }
                                    />
                                  </FormGroup>
                                  {validationsReminder.checkEffectiveness}
                                </div>
                                <div className="bx--col-md-4 bx--col-lg-6">
                                  <FormGroup legendText="Date of the effectiveness check">
                                    <DateTimePicker
                                      value={this.state.model.dateCheck}
                                      type="date"
                                      placeholder={DateFormat}
                                      name="dateCheck"
                                      alt="model"
                                      onChange={this.updateState}
                                      className="open-up"
                                      invalid={validationsReminder.dateCheck != null}
                                      disabled={
                                        this.state.model.emailCompilerAuditReport === user.email
                                      }
                                    />
                                  </FormGroup>
                                  {validationsReminder.dateCheck}
                                </div>
                                {/* RITM0945960 - Effectiveness Check Modification */}
                                <div className="bx--col-md-4 bx--col-lg-6">
                                   <FormGroup legendText="Is the corrective actions suitable for the purpose?*">
                                        <ComboBox
                                         id="isCorrectiveActionsSuitable"
                                         placeholder="Select"
                                         name="isCorrectiveActionsSuitable"
                                         alt="model"
                                         onChange={(id, val) =>
                                          this.updateState(id, (val ? val.text : null), 'model')}
                                         itemToString={item => (item ? item.text : '')}
                                         initialSelectedItem={selectedItemCombo.isCorrectiveActionsSuitable}
                                         items={this.state.appCorrectiveActionsSuitable}                                                                                                                 
                                         invalid={validationsReminder.isCorrectiveActionsSuitable != null}
                                         disabled={
                                           this.state.model.emailCompilerAuditReport === user.email
                                           }
                                        />                                         
                                   </FormGroup>
                                      {validationsReminder.isCorrectiveActionsSuitable}
                                </div>
                                {/* End */}
                              </>
                            ) : null}
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bx--row table-culumn-actions">
                    <Button
                      onClick={() => this.cancel()}
                      className="bx--col bx--btn--max-width"
                      size="default"
                      kind="secondary"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => this.saveCA()}
                      disabled={
                        !IsEditable(
                          'Audit',
                          'CARManagement',
                          user,
                          this.state.model?.idStatus,
                          'Effectiveness',
                          this.state.model?.auditCAR
                        )
                          ? owner
                            ? !IsEditable(
                                'Audit',
                                'CAManagement',
                                user,
                                this.state.model.idStatus,
                                'ImmediateThreatment',
                                { email: this.state.model.owner.email }
                              )
                            : true
                          : false
                      }
                      className="bx--col bx--btn--max-width"
                      size="default"
                      kind="primary"
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}
